exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".media-article-list-component{width:80%;margin-left:10%;height:auto}.media-article-list-component .bottom{height:1px;margin:auto;background-color:#ccc}.media-article-list-component .ads{margin-top:40px}.media-article-list-component .view-count{font-size:12px;color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/MediaArticleList.scss
// module id = 650
// module chunks = 0